import { Reveal } from "../Reveal";

export const PullQuote = ({ quote, attribution }) => (
  <section data-testid="pullquote-section" className="relative bg-[#0f0f0f] border-y border-white/10 py-20 sm:py-28">
    <div className="mx-auto max-w-[1200px] px-5 sm:px-8">
      <Reveal>
        <span className="font-display text-7xl sm:text-8xl text-[#e62429] leading-none block">
          &ldquo;
        </span>
        <blockquote className="font-display uppercase text-white text-3xl sm:text-5xl lg:text-6xl leading-[1] -mt-6">
          {quote}
        </blockquote>
        {attribution && (
          <p className="mt-6 text-sm uppercase tracking-[0.25em] font-bold text-neutral-500">
            {attribution}
          </p>
        )}
      </Reveal>
    </div>
  </section>
);
